<div
  class="slide-spacer"
  [style.height.vw]="slideData?.height">
  @if (slideData?.ruler?.enabled) {
    <div class="slide-spacer__ruler" [style.backgroundColor]="slideData?.ruler?.color"></div>
  }
</div>
